import React, { SyntheticEvent } from "react";
import { UserBikeModel } from "../../Models/UserBikeModel";
import UserBike from "../UserBike/UserBike";

interface Props {
  searchResults: UserBikeModel[];
}

const BikeList: React.FC<Props> = ({
  searchResults,
}: Props): JSX.Element => {
  return (
    <div>
      {searchResults.length > 0 ? (
        searchResults.map((result) => {
          return (
            <UserBike
            userBikeModel = {result!}
            />
          );
        })
      ) : (
        <p className="mb-3 mt-3 text-xl font-semibold text-center md:text-xl">
          No saved bikes - Add a bike on search to continue
        </p>
      )}
    </div>
  );
};

export default BikeList;